import { escapeHtml } from "../utils/escape";
import type { Translator } from "../i18n/resolve";

export const POWERED_BY_URL = "https://mabellenote.com/?utm_source=widget";

export const renderFooter = (translate: Translator, enabled: boolean): string => {
  if (!enabled) return "";
  const label = escapeHtml(translate("poweredBy"));
  return `<footer class="mbn-footer"><a class="mbn-footer-link" href="${POWERED_BY_URL}" target="_blank" rel="noopener nofollow">${label}</a></footer>`;
};
